import React from 'react';

const PageLoader = () => (
  <div className="pageloader is-active">
    <span className="title page-loader">
      <img src={`${process.env.PUBLIC_URL}/images/omnislots_preloader_loop.gif`} alt="Omnislots" />
    </span>
  </div>
);

export default PageLoader;
